// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2zvDJ","box":"WorkspacesBox_box__1Tgcj","node":"WorkspacesBox_node__1HiqN"};